<template>
   <!-- "Columns" button: tick the columns to show -->
   <div class="btn-group btn-group-sm">
      <button
         type="button"
         ref="toggleButton"
         class="btn btn-secondary dropdown-toggle"
         data-bs-toggle="dropdown"
         data-bs-auto-close="outside"
         title="Choose columns"
      >
         <i class="fa fa-columns"></i><span class="d-none d-sm-inline"> Columns</span>
         <span v-if="modelValue.length" class="badge bg-warning text-dark ms-1" title="Hidden columns">
            {{ modelValue.length }}
         </span>
      </button>

      <ul class="dropdown-menu dropdown-menu-end column-chooser">
         <li><h6 class="dropdown-header">Show columns</h6></li>
         <li v-for="column in columns" :key="column.key">
            <label class="dropdown-item d-flex align-items-center gap-2">
               <input
                  type="checkbox"
                  class="form-check-input m-0"
                  :checked="!modelValue.includes(column.key)"
                  @change="toggle(column.key)"
               />
               {{ column.label }}
            </label>
         </li>
         <li><hr class="dropdown-divider" /></li>
         <li>
            <button
               type="button"
               class="dropdown-item"
               :disabled="!modelValue.length"
               @click="$emit('update:modelValue', [])"
            >
               <i class="fa fa-undo fa-fw me-1"></i> Show all columns
            </button>
         </li>
      </ul>
   </div>
</template>

<script>
// modelValue = the HIDDEN column keys, e.g. ["email", "phonenumber"]
// (columns added to a page later show by default)
export default {
   name: "ColumnChooser",
   props: {
      columns: { type: Array, default: () => [] },     // [{ key: "email", label: "Email" }]
      modelValue: { type: Array, default: () => [] },  // hidden keys
   },
   emits: ["update:modelValue"],
   // The button's classes are fixed in the template, so Vue never redraws them
   // (a redraw would remove Bootstrap's "show" class and the menu would not close on an outside click).
   // Blue when columns are hidden, grey otherwise: switched here instead.
   mounted() {
      this.setButtonColour();
   },
   watch: {
      modelValue() {
         this.setButtonColour();
      },
   },
   methods: {
      setButtonColour() {
         const button = this.$refs.toggleButton;
         if (!button) return;
         const anyHidden = this.modelValue.length > 0;
         button.classList.toggle("btn-primary", anyHidden);
         button.classList.toggle("btn-secondary", !anyHidden);
      },
      toggle(key) {
         const hidden = this.modelValue.includes(key)
            ? this.modelValue.filter((k) => k !== key)
            : [...this.modelValue, key];
         this.$emit("update:modelValue", hidden);
      },
   },
};
</script>

<style scoped>
.column-chooser .dropdown-item {
   cursor: pointer;
}
.column-chooser .form-check-input {
   cursor: pointer;
}
</style>